module.exports = __webpack_public_path__ + "img/1050Y.9a3899b8.png";